import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { FreshdeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm2/FreshdeskTicketsForm';

export const AddFreshdeskTicketsPopup = ({
  trigger,
  knowledgeBaseId,
  disabled = false,
}: {
  trigger: React.ReactNode;
  knowledgeBaseId: number;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const close = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger
        disabled={disabled}
        asChild
        className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
      >
        {trigger}
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle className={'px-4'}>Freshdesk Tickets Integration</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4">
          <div className="content min-h-[510px]">
            <FreshdeskTicketsForm
              freshdeskIntegrationType={'Tickets'}
              closePopup={close}
              backButtonVisible={false}
              knowledgeBaseId={knowledgeBaseId}
              initialRequest={{ run_immediately: false }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
